/**
 * Error handling utility functions
 */

import logger from '../services/logger';

/**
 * Extract error message from API response
 * @param {Error} error - The error object
 * @param {string} defaultMessage - Default error message
 * @returns {string} - Formatted error message
 */
export const getErrorMessage = (error, defaultMessage = 'Bir hata oluştu') => {
  if (!error.response?.data?.detail) {
    return defaultMessage;
  }

  const detail = error.response.data.detail;

  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an array (validation errors), join them
  if (Array.isArray(detail)) {
    return detail.map(err => {
      if (typeof err === 'string') {
        return err;
      }
      if (err.msg) {
        return err.msg;
      }
      if (err.message) {
        return err.message;
      }
      return JSON.stringify(err);
    }).join(', ');
  }

  // If detail is an object, try to extract meaningful message
  if (typeof detail === 'object') {
    if (detail.message) {
      return detail.message;
    }
    if (detail.msg) {
      return detail.msg;
    }
    if (detail.error) {
      return detail.error;
    }
    return JSON.stringify(detail);
  }

  return defaultMessage;
};

/**
 * Handle API errors with proper message formatting
 * @param {Error} error - The error object
 * @param {string} defaultMessage - Default error message
 * @param {Function} messageError - Function to show error message
 */
export const handleApiError = (error, defaultMessage, messageError) => {
  const errorMessage = getErrorMessage(error, defaultMessage);
  if (messageError) {
    messageError(errorMessage);
  }
  logger.error('API Error:', error);
};
